export function calcularTotalCuotaSimulador(
    {vencimientoEnDias,
    Amount,
    admon,
    tasa}) {

    //Calcular interes
    const tasaParsed = parseFloat(tasa);
    const interest = Math.round(
        Amount * (tasaParsed / 100) * vencimientoEnDias
    );

    //Calcular IVA
    const iva = Math.round(admon * (19 / 100));
    console.log(Amount, interest, admon, iva);
    //Calcular Total
    const total = Math.round(Amount + interest + admon + iva);
    return total;
}